import React from "react";
import "./index.css";

interface ActionBarProps {
  workflowStep: "group" | "assign" | "actual";
  
}

const ActionBar: React.FC<ActionBarProps> = ({
  workflowStep,
}) => {
  
  return (
    <div className="action-bar">
        <div className="delivery-header__content">
          <h1 className="delivery-header__title">Delivery Route Optimizer</h1>
        
        </div>
    
     
    </div>
  );
};

export default ActionBar;